import React, { useEffect, useState } from "react";

export default function ScoreGauge({ score = 0, size = 220, label = "Opportunity Score" }) {
  const [display, setDisplay] = useState(0);
  const radius = (size - 24) / 2;
  const circumference = 2 * Math.PI * radius;

  useEffect(() => {
    let raf;
    const start = performance.now();
    const dur = 1200;
    const animate = (t) => {
      const p = Math.min(1, (t - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.max(0, Math.min(100, Math.round(eased * score))));
      if (p < 1) raf = requestAnimationFrame(animate);
    };
    raf = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(raf);
  }, [score]);

  const color = score >= 70 ? "#16A34A" : score >= 45 ? "#2563EB" : "#D97706";
  const offset = circumference - (display / 100) * circumference;

  return (
    <div className="flex flex-col items-center" data-testid="score-gauge">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="rgba(148,163,184,0.25)" strokeWidth={12} />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth={12}
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="butt"
            style={{ transition: "stroke-dashoffset 0.1s linear" }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-mono-data text-5xl font-semibold tracking-tight" style={{ color }} data-testid="score-value">
            {display}
          </span>
          <span className="mono-label mt-1">/ 100</span>
        </div>
      </div>
      <span className="mono-label mt-3">{label}</span>
    </div>
  );
}
